import { render } from "./index.vue?vue&type=template&id=972cf3f0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=972cf3f0&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__